var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFingerprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fingerprint",
    transform: "translate(0 -0.177)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7051",
    "data-name": "Rectangle 7051",
    width: 24,
    height: 24,
    transform: "translate(0 0.177)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64993",
    "data-name": "Path 64993",
    d: "M50.7,87.916a11.818,11.818,0,0,0,1.234-5.278A5.955,5.955,0,0,1,54.16,78",
    transform: "translate(-45.997 -70.53)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64994",
    "data-name": "Path 64994",
    d: "M106.226,128A17.736,17.736,0,0,1,104,136.627",
    transform: "translate(-94.353 -115.892)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64995",
    "data-name": "Path 64995",
    d: "M96,98.968a2.968,2.968,0,1,1,5.937,0,20.621,20.621,0,0,1-1.976,8.849",
    transform: "translate(-87.095 -86.86)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64996",
    "data-name": "Path 64996",
    d: "M44.32,46.1a27.328,27.328,0,0,0,.5-5.195,8.905,8.905,0,1,0-17.81,0,8.757,8.757,0,0,1-.51,2.968",
    transform: "translate(-24.042 -28.797)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64997",
    "data-name": "Path 64997",
    d: "M76.379,160a15.018,15.018,0,0,1-1.679,4.443",
    transform: "translate(-67.771 -144.923)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64998",
    "data-name": "Path 64998",
    d: "M120,64.046a6.5,6.5,0,0,1,.742-.046,5.937,5.937,0,0,1,5.937,5.937,24.173,24.173,0,0,1-.186,2.968",
    transform: "translate(-108.869 -57.828)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64999",
    "data-name": "Path 64999",
    d: "M179.273,192c-.139.547-.3,1.095-.473,1.623",
    transform: "translate(-162.214 -173.955)",
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFingerprint);
export default __webpack_public_path__ + "static/media/fingerprint.b459fd28ef465f742bdcaed8093aab24.svg";
export { ForwardRef as ReactComponent };